import { v4 as uuidv4 } from "uuid";
import { DateFormatType, GeneralDialogMode } from "@/api/constants/enums";
import { DateUtil } from "@/utils/date.util";

const setStateGeneralDialog = (
	state: any,
	{
		opened,
		title = "",
		i18n = "",
		parameters,
		message = "",
		messages = [],
		source = "",
		mode = "",
		status = 0
	}: {
		opened: boolean;
		title?: string;
		i18n?: string;
		parameters?: Record<string, string>;
		message?: string;
		messages?: any[];
		source?: string;
		mode?: string;
		status?: number;
	}
) => {
	state.generalDialog = {
		uuid: uuidv4(),
		title,
		i18n,
		parameters,
		source,
		message,
		messages,
		mode,
		status,
		opened
	};
};

const setStateOverlay = (state: any, { active, text }) => {
	state.overlay = {
		active,
		text
	};
};

const activateDialog = (state: any, { title, i18n, parameters, message, messages, source, mode, status }) => {
	if (parameters) {
		if (parameters.date) {
			parameters.date = DateUtil.formatTimezoneDate({ value: parameters.date, format: DateFormatType.LONG_DATE_TIME });
		}
	}

	setStateGeneralDialog(state, { opened: true, title, i18n, parameters, message, messages, source, mode, status });
};

const activateInvalidFormDialog = (state: any, { i18n, parameters }: { i18n?: string; parameters?: Record<string, string> } = {}) => {
	setStateGeneralDialog(state, {
		opened: true,
		title: "common.invalidForm.title",
		i18n: i18n ?? "common.invalidForm.text",
		parameters,
		mode: GeneralDialogMode.FORM_ERROR
	});
};

const desactivateDialog = (state: any) => {
	setStateGeneralDialog(state, {
		opened: false
	});
};

const activateOverlay = (state: any, text: string) => {
	setStateOverlay(state, { active: true, text });
};

const desactivateOverlay = (state: any) => {
	setStateOverlay(state, { active: false, text: "" });
};

const updateStepperStep = (state: any, step: number) => {
	state.stepper.step = step;
};

export default {
	activateDialog,
	activateInvalidFormDialog,
	desactivateDialog,
	activateOverlay,
	desactivateOverlay,
	updateStepperStep
};
